import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bindActionCreators } from 'redux';

import { history } from '../../store';
import Planogram from '../replenish/planogram';
import SignedInHeader from '../signin/signedInHeader';
import CalibrationActions from './segments/actionButtons';
import SlotCalibrationInstruction from './segments/slotCalibrationInstruction';
import ProductSlotAssignment from './segments/productSlotAssignment';
import * as cabinetActions from './../../actions/cabinet';
import * as planogramActions from './../../actions/planogram';

const Calibration = ({
  cabinet,
  products,
  refillPlan,
  refillSchema,
  planogramConfig,
  t,
  cabinetActions,
  planogramActions,
  setting,
}) => {
  const [activeNav, setActiveNav] = useState('planogram');
  const [activeCalibrationPage, setActiveCalibrationPage] = useState('index');
  const [slotCalibrationData, setSlotCalibrationData] = useState({
    shelfNumber: null,
    slotData: {},
    count: 0,
  });

  useEffect(() => {
    //if user access the route directly or there is no device info, redirect to home page
    if (!cabinet.deviceCode) {
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activeNav === 'planogram') return;

    //if no deviceCode, return to the home page
    if (!cabinet.deviceCode) {
      history.push('/');
    }

    history.push(`/${cabinet.deviceCode}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeNav]);

  const handleCancelCalibration = () => {
    cabinetActions.cancelSlotCalibration(
      cabinet.deviceCode,
      slotCalibrationData.shelfNumber,
      slotCalibrationData.slotData.slot
    );
    setActiveCalibrationPage('index');
  };

  /**after training is complete, refetch planogram data on delay */
  const refetchPlanogramData = () => {
    setTimeout(() => {
      planogramActions.fetchPlanogram(cabinet.deviceCode, cabinet.group);
    }, 6000);
    history.push(`/${cabinet.deviceCode}`);
  };

  return (
    <div className="calibration__container">
      <SignedInHeader
        activeNav={activeNav}
        setActiveNav={nav => setActiveNav(nav)}
        t={t}
        cabinet={cabinet}
        planogramConfig={planogramConfig}
      />
      {(() => {
        //display calibration index page
        if (activeCalibrationPage === 'index') {
          return (
            <Fragment>
              <CalibrationActions
                t={t}
                startCalibration={() => {
                  cabinetActions.startCalibration(
                    cabinet.deviceCode,
                    cabinet.deviceSubType,
                    'scale1'
                  );
                }}
                endCalibration={() => {
                  cabinetActions.endCalibration(cabinet.deviceCode, '1');
                  refetchPlanogramData();
                }}
              />
              {cabinet.calibration === 'off' && (
                <div className="calibration__label">
                  {t('common:selectSlot')}
                </div>
              )}
              {cabinet.calibration === 'on' && (
                <div className="calibration__label">
                  {/*
                    <div className="calibration__label-icon">
                        <span></span>
                      </div>
                      */}
                  <div className="calibration__instruction-text calibration__instruction-text--narrow">
                    {t('common:calibrationInProgress')}
                  </div>
                </div>
              )}
              <div className="calibration__planogram">
                <Planogram
                  cabinet={cabinet}
                  products={products}
                  replenishPlan={refillPlan}
                  refillSchema={refillSchema}
                  t={t}
                  slotSelected={data => {
                    setSlotCalibrationData({
                      shelfNumber: data.shelfNumber,
                      slotData: data.slotData,
                      product: data.product,
                      count: 0,
                    });
                    setActiveCalibrationPage('startSlotCalibration');
                  }}
                  planogramConfig={planogramConfig}
                  cabinetSetting={setting}
                />
              </div>
            </Fragment>
          );
        }

        //An instruction to touch the selected slot for starting the calibration
        if (activeCalibrationPage === 'startSlotCalibration') {
          return (
            <SlotCalibrationInstruction
              shelf={slotCalibrationData.shelfNumber}
              slot={slotCalibrationData.slotData.slot}
              text={t('common:pressSlotToCalibrate')}
              cabinet={cabinet}
              onGoNext={() => {
                cabinetActions.startEmptyShelf(
                  cabinet.deviceCode,
                  slotCalibrationData.shelfNumber,
                  slotCalibrationData.slotData.slot
                );
                setActiveCalibrationPage('confirmSlotEmpty');
              }}
              onGoBack={() => setActiveCalibrationPage('index')}
              t={t}
              buttonText={t('common:next')}
            />
          );
        }

        //confirm that the slot is empty
        if (activeCalibrationPage === 'confirmSlotEmpty') {
          return (
            <SlotCalibrationInstruction
              shelf={slotCalibrationData.shelfNumber}
              slot={slotCalibrationData.slotData.slot}
              cabinet={cabinet}
              text={t('common:confirmSlotEmptied')}
              onGoNext={() => {
                cabinetActions.endEmptyShelf(
                  cabinet.deviceCode,
                  slotCalibrationData.shelfNumber,
                  slotCalibrationData.slotData.slot
                );
                setActiveCalibrationPage('productSelection');
              }}
              onGoBack={() => handleCancelCalibration()}
              t={t}
              buttonText={t('common:confirm')}
              calibrationState={activeCalibrationPage}
            />
          );
        }

        //select and assign product to the slot page
        if (activeCalibrationPage === 'productSelection') {
          return (
            <ProductSlotAssignment
              save={() => setActiveCalibrationPage('productSelection')}
              onGoBack={() => setActiveCalibrationPage('index')}
              t={t}
              cabinet={cabinet}
              shelfNumber={slotCalibrationData.shelfNumber}
              slotData={slotCalibrationData.slotData}
              allProducts={products.products || []}
              setCalibrationData={data => {
                setSlotCalibrationData({ ...slotCalibrationData, ...data });
                setActiveCalibrationPage('index');
              }}
            />
          );
        }
      })()}
    </div>
  );
};

const mapStateToProps = state => ({
  cabinet: state.cabinet,
  products: state.products,
  refillPlan: state.replenishPlan,
  refillSchema: state.replenishRule,
  planogramConfig: state.planogram,
  setting: state.setting,
});

const mapActionToProps = dispatch => ({
  cabinetActions: bindActionCreators(cabinetActions, dispatch),
  planogramActions: bindActionCreators(planogramActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapActionToProps
)(translate()(Calibration));
